import Keycloak from 'keycloak-js';
/*
    => use .server or .client in the file name to load the plugin only on the server or client side
 */
export default defineNuxtPlugin({
  async setup(nuxtApp) {
    const config = useRuntimeConfig();

    nuxtApp.$keycloak = new Keycloak({
      url: config.public.keycloakUrl,
      realm: config.public?.keycloakRealm,
      clientId: config.public?.keycloakClientId,
    });
  },
});
